import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityButton } from './button';
import { link } from './link';

export const SanitySombraButton = SanityButton.extend({
  _key: z.string(),
});
export type SanitySombraButton = z.infer<typeof SanitySombraButton>;

export const SanitySombraStack = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('sombraStack'),
  _key: z.string(),
  eyebrow: z.string().optional().nullable(),
  title: z.string(),
  notes: z.array(z.string()).optional().nullable(),
  buttons: z.array(SanitySombraButton).optional().nullable(),
});
export type SanitySombraStack = z.infer<typeof SanitySombraStack>;

export const sombraStack = groq`{
  eyebrow,
  title,
  notes,
  buttons[] {
    _key,
    ...(link[0] ${link}),
    variant,
  },
}`;
